import { render, staticRenderFns } from "./riskRuleDetail.vue?vue&type=template&id=44044f22&scoped=true"
import script from "./riskRuleDetail.vue?vue&type=script&lang=js"
export * from "./riskRuleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44044f22",
  null
  
)

export default component.exports